import script from "./InstructionLBSPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionLBSPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionLBSPage.vue?vue&type=style&index=0&id=cee905b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee905b4"]])

export default __exports__